import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: () => import('../views/UserManagement.vue'),
    meta: { requiresAuth: true, requiresUserManagement: true }
  },
  // ─── Suite-aware admin (Phase 4) ─────────────────────────────────
  {
    path: '/customers',
    name: 'Customers',
    component: () => import('../views/Customers.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/customers/:id',
    name: 'CustomerDetail',
    component: () => import('../views/CustomerDetail.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/tiers',
    name: 'Tiers',
    component: () => import('../views/Tiers.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/anomalies',
    name: 'AnomalyQueue',
    component: () => import('../views/AnomalyQueue.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  
  // Initialize auth if authenticated but user not loaded
  if (isAuthenticated && !store.getters['auth/currentUser']) {
    await store.dispatch('auth/initAuth');
  }
  
  const isAdmin = store.getters['auth/isAdmin'];
  const currentUser = store.getters['auth/currentUser'];
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && isAuthenticated) {
    next('/');
  } else if (to.meta.requiresAdmin && !isAdmin) {
    next('/');
  } else if (to.meta.requiresUserManagement) {
    // Allow admins
    if (isAdmin) {
      next();
    } else if (currentUser?.role === 'product' && currentUser?.managedProducts?.length > 0) {
      // Allow product users with assigned products
      next();
    } else {
      // Redirect others to dashboard
      next('/');
    }
  } else {
    next();
  }
});

export default router;